import { createZodFormikValidationAdapter } from "@oefr/zod-form"

export const zodFormikValidation = createZodFormikValidationAdapter()
